
<ckeditor [(ngModel)]="editorContent" (ngModelChange)="onContentChange($event)" [editor]="Editor" (ready)="onReady($event)" [config]="config" [ngModelOptions]="{ standalone: true }"></ckeditor>


    
